import { SetNewPasswordProps } from '.';
import { useTranslation } from 'react-i18next';
import FormManager from '@app/components/EasyForm';
import { useSearchParams } from 'react-router-dom';
import controllerConfigs from './controller.config';
import AppDispatcher from '@app/events/app-commander';
import ChangePasswordFormListener from './form.listener';
import DomainModuleFactory from '@core/domain/index.module';
import React, { useState, FormEvent, ComponentType } from 'react';

export default function setNewPasswordHoc(Page: ComponentType<SetNewPasswordProps>): ComponentType<{}> {
  return function Adapteed(props: any): JSX.Element {
    //
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);

    const handleOnSubmit = (ev: FormEvent) => {
      ev.preventDefault();

      setIsLoading(true);

      const requestToken = searchParams.get('token');

      if (!requestToken) {
        setIsLoading(false);
        AppDispatcher.showToast({ mode: 'error', message: 'INVALID_TOKEN_CONFIRMATION' });
        return;
      }

      if (!formManager.isValid()) {
        setIsLoading(false);
        return;
      }

      const { password } = formManager.getData();

      ResetPasswordUseCase.execute({ password, token: requestToken })
        .then(() => {
          AppDispatcher.visitPage({ path: '/login' });
          AppDispatcher.showToast({ mode: 'success', message: 'PASSWORD_RESETED_SUCCESS' });
        })
        .catch(({ code }) => AppDispatcher.showToast({ mode: 'error', message: code }))
        .finally(() => setIsLoading(false));
    };

    return <Page {...props} t={t} isLoading={isLoading} controllers={controllers} handleOnSubmit={handleOnSubmit} />;
  };
}

const defaultState = { password: '', confirmPassword: '', captchaToken: '' };
export const formManager = new FormManager({ formIndex: 'set-new-password', defaultState, controllersHandlers: new ChangePasswordFormListener() });
const controllers = formManager.initControllers(controllerConfigs);

const ResetPasswordUseCase = DomainModuleFactory.auth().createResetPasswordUseCase();
